import { Component, OnInit, HostListener } from '@angular/core';
import { NavController, MenuController } from '@ionic/angular';
import { AppService } from '../services/app.service';
import { HttpService } from '../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SyncService } from '../services/sync.service';
import { AlertController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';

import { Observable, ZenObservable } from 'zen-observable-ts';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

import {Client, State, 
  Conversation,
  ConversationUpdateReason,
  Message,
  SendMediaOptions,
  Paginator,
  MessageUpdateReason,
  Participant,
  ParticipantUpdateReason} from "@twilio/conversations";
import { throwError } from 'rxjs';

//twilio video
declare var document: any;

declare var participantConnected;
declare var participantDisconnected;
declare var viewLink;
//end twilio video

@Component({
  selector: 'app-exp',
  templateUrl: './exp.page.html',
  styleUrls: ['./exp.page.scss'],
})
export class ExpPage implements OnInit {


  subscription: ZenObservable.Subscription;
  flags: any;
  room: any;

  client: any;
  conversation: any;
  token: any;
  
  Video:any = require('twilio-video');

  constructor(public app: AppService, private sanitizer: DomSanitizer, public menuCtrl: MenuController, public sync: SyncService, private navCtrl: NavController, public http: HttpService, private router: Router, private activatedRoute: ActivatedRoute, public alertController: AlertController) { 
    //http://localhost:8100/exp/1/16/support/82/155

    this.flags = {
      identity: 'Client',
      date: Date.now(),
      sid: null,
      editSite: null,
      currentCategory: null,
      currentEntry: null,

      contactOption: null,

      twilioConnectionMode: 3,
      twilioConnectionVideo: false,
      
      convoNewMessage: '',
      convoSysMessage: null,
      convoMessages: [],
      convoVideoParams: { audio: true, video: true },
      convoPauseState: 0,

      supportView: 0,
      endingSurvey: false,
      
      sessionID: null,
      session: null,
      connectionType: null,
      completeSession: false,
      currentSlide: 0,
      responses: [],
      
      appSync: null,
      increment: 0,


      site: null,

      defaultSession: {
        status: 1,
        data: { url: null },
        company_id: null,
        site_id: null,
        device_id: null,
        epoch: null,
        name: 'New Request',
        responses: {},
        commands: {},
        notes: '',
      }
    }

    //company 1 > arii
    //site 10 > kingsway
    //device 82 > DC Test
   }



  //SCREEN RESIZE LISTENER
  mobileScreen: boolean = window.innerWidth < 768;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    
    this.mobileScreen = window.innerWidth < 768;
  }
  //END SCREEN RESIZE LISTENER

    
   ionViewWillEnter() {
    this.flags.appSync = null;
    this.menuCtrl.enable(false);
    
    this.token = this.activatedRoute.snapshot.paramMap.get('token');
    this.flags.sessionID = this.activatedRoute.snapshot.paramMap.get('session_id');

    if(this.token) {
      this.getData();
      //this.getSites();
    }


    // this.company_id = this.activatedRoute.snapshot.paramMap.get('company_id');
    // this.site_id = this.activatedRoute.snapshot.paramMap.get('site_id');
    // this.function = this.activatedRoute.snapshot.paramMap.get('function');
    // this.device_id = this.activatedRoute.snapshot.paramMap.get('device_id');
    //this.subscribe();

   }


   

   getData() { //GET SITE INFO
    this.http.get('https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/device/' + this.token).then(data => {

      if(data['data']) {
        
        console.log('GOT DATA', data);
        var obj = data['data'];
        obj.settings = JSON.parse(obj.settings);
        obj.site_settings = JSON.parse(obj.site_settings);

        for (var o in obj.sites) { //iterate through query
          obj.sites[o].contacts = JSON.parse(obj.sites[o].contacts);
          obj.sites[o].settings = JSON.parse(obj.sites[o].settings);
          obj.sites[o].directory = JSON.parse(obj.sites[o].directory);

          for (var i in obj.sites[o].join) { //iterate through query
            obj.sites[o].join[i].entries = JSON.parse(obj.sites[o].join[i].entries);
            obj.sites[o].join[i].settings = JSON.parse(obj.sites[o].join[i].settings);
          }
          obj.sites[o].instance_settings =  obj.site_settings.find(e => e.id == obj.sites[o].id);
        }
        

        this.flags.device = obj;
        this.flags.sites = obj.sites;

        console.log('FORMATTED ', obj);


        //if a single site then just go directly to experience
        if(this.flags.sites.length == 1 && !this.flags.device.settings.links.length) { 
          this.selectSite(0);
        }


        //if session id is passed then subscribe to the ticket
        if(this.flags.sessionID) {
          this.subscribe();
        }
      }
    });
   }


   selectSite(i) {
    if(i != null) { this.flags.currentSite = i; } //set current site if passed index

    var obj = JSON.parse(JSON.stringify(this.flags.sites[this.flags.currentSite]));
    this.flags.editSite = obj;
    console.log("SELECTeD STIE", obj);

    //VCARD
    var vcard = ' BEGIN:VCARD\nVERSION:4.0';
    vcard += '\nFN:' + this.flags.editSite.name;
    vcard += '\nTEL;TYPE=WORK:' + this.flags.editSite.settings.supportPhoneLink;
    vcard += '\nEMAIL:'+this.flags.editSite.email;
    vcard += '\nADR:'+this.flags.editSite.address
    vcard += '\nURL:'+this.flags.editSite.website
    vcard += '\nEND:VCARD';
    this.flags.editSite.vcard = vcard;

    this.flags.currentCategory = null;
    this.flags.currentEntry = null;
   }

   selectCategory(item) {
    this.flags.currentCategory = item;
    this.scrollTop();
   }

   selectEntry(item) {
    if(item.type == 'external') {
      window.open(item.target, '_blank');
    } else {
      this.flags.currentEntry = item;
      this.scrollTop();
    }
   }


   openLink(item) {
    window.open(item.target, '_blank');
   }

   scrollTop() {
    var element = document.getElementById("supportPage");
    element.scrollTop = 0;
   }

   scrollBottom() {
    var element = document.getElementById("supportPage");
    element.scrollTop = element.scrollHeight;

    this.flags.animateContact = true;
    setTimeout(() => {
      this.flags.animateContact = false;  
    }, 1000);
   }


   homeButton() {
    this.flags.currentCategory = null; 
    this.flags.currentEntry = null

    var element = document.getElementById("supportPage");
    element.scrollTop = 0;


    //take back to site selection screen
    if(this.flags.sites.length > 1) {
      this.flags.editSite = null;
    }
   }

   createSession(m) {
    this.app.load('Connecting', 1000);
    this.app.flags.connectionType = m; //set flag for defaulting the camera on or off
    
    var source = 'chat';
    if(this.flags.device.type == 'kiosk') { source = 'kiosk'; }



    var obj = {
      token: this.token,
      site_id: this.flags.editSite.id,
      source_type: source,
    };

    // var obj2 = {
    //   site_id: this.flags.editSite.id,
    //   device_id: this.flags.device.id,
    //   company_id: this.flags.editSite.company_id,
    //   language: this.flags.editSite.language,
    //   source_type: source,
    //   source: this.flags.device.name
    // }

    this.http.post('https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/device/' + this.token, obj).then(data => {
        //this.app.toast('Saved', 'success');
        console.log(data);
  
        if(data['data'].insertId) {
          //this.flags.sessionID = data['data'].insertId;
          //this.subscribe();


          //navigate to new page
          var id = data['data'].insertId
          this.navCtrl.navigateRoot('/exp/'+this.token+'/'+id);
        }


        

        //this.getSites();
        //this.reset();
      });
   }



   reset() {
      this.navCtrl.navigateRoot('/exp/'+this.token);
   }

   
  //  updateFeed() { //notify app sync to refresh
  //   var obj = '{}';

  //   var syncTarget = 'comp-' + this.flags.device.company_id;

  //   this.sync.UpdateSync({ id: syncTarget, status: status, data: obj, responses: 'null', commands: 'companySessions', settings: 'null' }).then(data => {
  //     console.log(data.data);
  //     console.log('Sync updated', data);
  //     //this.flags.appSync = data;
  //   });
  // }
   

  rating(m) {
    this.flags.appSync.rating = m;
  }


  openModal(m) {
    this.flags.modalMode = m;
    this.flags.modalStep = 1;
  }

  closeModal() {
    this.flags.modalMode = null;
  }

   
  //START APP SYNC
  subscribe() {
    this.sync.GetMostRecentSync(this.flags.sessionID).then(data => {
        console.log('inital price from app sync', data);
        this.flags.appSync = data;
        this.renderSession();

        //SELECT SITE FIELDS
        for (let i = 0; i < this.flags.sites.length; i++) {
          if(this.flags.sites[i].id == this.flags.appSync.data.site_id) {
            this.selectSite(i);
          }
        }
        this.app.stopload();

        // if(!this.conversation && this.flags.appSync.data.status == 'new' || !this.conversation && this.flags.appSync.data.status == 'pending') { //if ticket is still open
        //   this.getTwilioToken(); //connect to twilio face
        // } 

        if(this.flags.appSync.data.status == 'closed') {
          this.listArchiveMessages();
          //this.flags.convoMessages = JSON.parse(this.flags.appSync.data.conversation);
        } else {
          this.getTwilioToken(); //connect to twilio face
        }
    });

    console.log('starting subscription');
    this.subscription = this.sync.OnUpdateSyncListener(this.flags.sessionID)
        .map((syncObject) => syncObject.value.data['onUpdateSync'])
        .subscribe((data) => {
          console.log('received update via app sync', data);
          this.flags.appSync.data = data.data;
          this.renderSession();
          
      }, (error) => {
          //this.app.alert('error' + error)
          console.log('logged a connection error', error);
          this.reSubscribe();
      });
  }

  unsubscribe() {
      this.subscription.unsubscribe();
      console.log('unsubscribe');
  }

  reSubscribe() {
    this.flags.online = false;
    console.log('subscription dead unsubscribing');
    this.unsubscribe();

    setTimeout(() => {
        console.log('retrying subscription');
        this.subscribe();
    }, 2000);
  }
  //END APP SYNC




  //TWILIO SYSTEMS
    getTwilioToken() {    
      //https://www.twilio.com/docs/video/api/rooms-resource#create-room
      var identity = 'Client';//                this.app.sysData.agent_name = data.data[0].name;
      var room = this.flags.sessionID;
      var sid = this.flags.appSync.data.conversation_sid;
      this.http.get('https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/token/?identity='+ identity +'&room='+ room + '&sid=' + sid).then(data => {
        console.log('GET CHAT/TICKET TOKEN', data);
        //this.app.alert(JSON.stringify(data));
        this.flags.twilioToken = data['token'];
        this.flags.tokenTimer = Date.now(); //current epoch - token is valid for 1 hour
        
        //TWILIO CONVERSATION INITIALIZER
        this.client = new Client(this.flags.twilioToken);

        this.flags.sid = data['conversationSid'];
        this.getConversation(data['conversationSid']);


        //buffer launch
        setTimeout(() => {
          this.checkTwilioToken();

          if(this.app.flags.connectionType == 'video') {
            console.log('CONNECTIGN TO ROOM-  video on');
            this.twilioConnect(2);
          } else if(this.app.flags.connectionType == 'audio') {
            console.log('CONNECTIGN TO ROOM- audio only');
            this.twilioConnect(1);
          } else {
            console.log('CONNECTIGN TO ROOM- no chat no video');
            this.twilioConnect(3);
          }
        }, 800);
        
      });
    }
  
    checkTwilioToken() {
      console.log('checking twilio token');
      var epoch = Date.now();
      var expiration = +epoch - +this.flags.tokenTimer;

      if(this.flags.twilioToken) {
        console.log('token timer', expiration);

        if(expiration >= 30*60*1000) {
          this.refreshTwilioToken();
          //this.getTwilioToken(); //refresh token
          //this.app.alert('Twilio Token needs to be refreshed, please refresh the page.');
        }


        setTimeout(() => {
          this.checkTwilioToken();
        }, 5*60*1000);
      }
    }


    async refreshTwilioToken() {
      console.log('OLD', this.client);
      //this.client = new Client(this.flags.twilioToken);
      var identity = 'Client';//                this.app.sysData.agent_name = data.data[0].name;
      var room = this.flags.sessionID;
      var sid = this.flags.appSync.data.conversation_sid;

      this.http.get('https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/twilio/token/?identity='+ identity +'&room='+ room + '&sid=' + sid).then(data => {
        this.flags.twilioToken = data['token'];
        this.client = new Client(this.flags.twilioToken);
        this.flags.tokenTimer = Date.now();
        console.log('NEW', this.client);
      });
    }
  // async diagDelete() {
  //   var conversation = await this.client.getConversationByUniqueName('240');
  //   await conversation.delete();
  //   var conversation = await this.client.getConversationByUniqueName('363');
  //   await conversation.delete();
  //   var conversation = await this.client.getConversationByUniqueName('361');
  //   await conversation.delete();
  //   console.log('deleted');
  // }

  getConversation(sid) {
    //https://www.twilio.com/docs/conversations/quickstart#add-an-sms-participant-to-a-conversation
    //https://media.twiliocdn.com/sdk/js/conversations/releases/2.1.0/docs/classes/Client.html#userSubscribed

    //this.client.getConversationByUniqueName(id).then(data => { //get convo by unique name
    this.client.getConversationBySid(sid).then(data => { //get convo by sid name
      this.conversation = data; //attach variable to conversation
      console.log('Connected ', data);

      //this.listConversationParticipants()
      this.listMessages(); //list initial messages
      this.subscribeConversation(); //subscribe for updates
    }).catch(e => {
      //this.app.alert('C1: error' + e);

      console.log('CLIENT FAILED ', this.client);
      console.log('NO CONVERSATION EXISTS CREATING A NEW ONE')
      this.app.alert('An error occured connecting to conversation, please try again');
    }); 
  }


  subscribeConversation() { //handle events in the conversation
    this.client.on("conversationUpdated", ({conversation, updateReasons}: {
      conversation: Conversation,
      updateReasons: ConversationUpdateReason[]
    }) => {
        // Fired when the attributes or the metadata of a conversation have been updated
        console.log('something updated in chat' + updateReasons, conversation);
        this.listMessages();
    });
  }

  listArchiveMessages() {
    var messages = JSON.parse(this.flags.appSync.data.conversation);

    for (let i = 0; i < messages.length; i++) {
      //const urlRegex = /((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
      const urlRegex = /(website: https?:\/\/[^\s]+)/g;
      var str = messages[i]['state']['body'];

      console.log(str);
      str = str.replace(urlRegex, '<a onclick="viewLink(`$1`)" class="pointer">Click to view</a>');
      messages[i]['state']['message'] = this.sanitizer.bypassSecurityTrustHtml(str);
      
      this.flags.convoMessages.push(messages[i]);
    }
    this.scrollChat();
  };



  async listMessages() {
    var limit = 1000; //initial load limit
    if(this.flags.convoMessages.length) {
      limit = 1; //subsequent limit
    }

    console.log(limit + 'pull')

    let messagesPaginator: Paginator<Message> = await this.conversation.getMessages(limit);
    const messages: Message[] = messagesPaginator.items;

    
    for (let i = 0; i < messages.length; i++) {
      if(limit == 1000 || messages[i]['state']['sid'] != this.flags.convoMessages[+this.flags.convoMessages.length - 1]['state']['sid']) {
        //const urlRegex = /((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
        const urlRegex = /(website: https?:\/\/[^\s]+)/g;
        var str = messages[i]['state']['body'];

        //console.log(str);
        str = str.replace(urlRegex, '<a onclick="viewLink(`$1`)" class="pointer">Click to view</a>');
        messages[i]['state']['message'] = this.sanitizer.bypassSecurityTrustHtml(str);
        
        this.flags.convoMessages.push(messages[i]);
      }
    }

    this.scrollChat();

    console.log('got messages', this.flags.convoMessages);
    console.log('got messages firect', messages);
  }


  scrollChat() {
    setTimeout(() => {    // Scroll to the element
      const element = document.querySelector('a[name="chatTarget"]');    
      element.scrollIntoView({ behavior: 'smooth' });      
    }, 200);
  }




  async sendMessage(m) {
    if(this.conversation && this.flags.convoNewMessage && m == 1) {
      var obj:any = this.flags.convoNewMessage;
      this.flags.convoNewMessage = '';
      this.conversation.sendMessage(obj);
      
      if(this.mobileScreen) {
        document.activeElement.blur();
      }
    }

    if(this.conversation && this.flags.convoSysMessage && m == 2) {
      var obj:any = this.flags.convoSysMessage;
      this.flags.convoSysMessage = '';
      this.conversation.sendMessage(obj);
    }
  }





  twilioConnectPreview(m) {
    if(m == 0) {
      if (this.flags.localVideoTrack) { this.flags.localVideoTrack.stop(); }
      var div = document.getElementById('localVideoFeed');
      if (div) { div.remove(); }
    }
    if(m == 1) { //show local preview
      const localVideoElement = document.getElementById('localVideo');
      const div = document.createElement('div');
      div.id = "localVideoFeed";
      div.className = "localVideo";


      this.Video.createLocalVideoTrack().then(track => {
        this.flags.localVideoTrack = track;
        div.appendChild(track.attach());
        localVideoElement.appendChild(div);
      }).catch(error => {
        console.error(`Error creating local video track: ${error}`);
      });
    }
  }


  twilioConnect(m) { 
    if(m) { this.flags.twilioConnectionMode = m; } //set connection varialbe to match m

    if (this.flags.twilioConnectionMode == 1) { //if audio only
      this.flags.convoVideoParams.video = false;
      this.flags.convoVideoParams.audio = true;
      this.flags.convoPauseState = 0;
      this.flags.convoSysMessage = 'Joined on audio'; 
      this.twilioConnectPreview(0);
    }

    if (this.flags.twilioConnectionMode == 2) { //if video and audio
      this.flags.convoVideoParams.video = true;
      this.flags.convoVideoParams.audio = true;
      this.flags.convoPauseState = 0;
      this.flags.convoSysMessage = 'Joined on video';
      this.twilioConnectPreview(1);
    }

    if(this.flags.twilioConnectionMode == 3) { //pause
      this.flags.convoVideoParams.video = false;
      this.flags.convoVideoParams.audio = false;
      this.flags.convoPauseState = 1;
      this.flags.convoSysMessage = 'Disconnected video & audio';
      this.twilioConnectPreview(0);
    }

    this.Video.connect(this.flags.twilioToken, this.flags.convoVideoParams).then(room => {
      this.room = room;

      if(m == null) {
        this.sendMessage(2);
      }

      console.log("CONNECTED TO ROOM ", room);
      room.participants.forEach(participantConnected);
      room.on('participantConnected', participantConnected);
      room.on('participantDisconnected', participantDisconnected);
      //room.once('disconnected', error => room.participants.forEach(participantDisconnected));
    });
  }

  checkTwilioConnections() {
    console.log('CURRENTLY ACTIVE TWILIO', this.room);
    console.log('size', this.room.participants.size);
    this.flags.twilioConnectionVideo = false;

    this.room.participants.forEach((item) => {
      
      console.log('for item ' + item);
      console.log('sid here', item.sid);
      console.log('tracks here', item.tracks);
    });
  }

  
  stopTwilioConnect() {
    this.twilioConnectPreview(0);
    this.room.disconnect();
    this.flags.convoSysMessage = 'Exited the conversation';
    this.sendMessage(2);
  }
  //END TWILIO SYSTEMS




  renderSession() {
    this.flags.appSync.data = JSON.parse(this.flags.appSync.data);
    this.flags.appSync.data.data = JSON.parse(this.flags.appSync.data.data);
    console.log('rendered data', this.flags.appSync);

    //this.app.alert(this.flags.appSync.data.site_id);
    
    // for (let i = 0; i < this.flags.sites.length; i++) {
    //   if(this.flags.sites[i].id == this.flags.appSync.data.site_id) {
    //     this.selectSite(i);
    //   }
    // }
    //this.flags.appSync.data.site_id
    //this.flags.editSite
  }


  closeSession() {
    var sid = this.flags.sessionID;
    this.app.load('Closing', 1000);
    var obj = {
      sid: this.flags.sessionID,
      source_type: 'Client',
    };
    this.flags.convoSysMessage = 'Closed the ticket';
    this.sendMessage(2);



    this.http.post('https://xmiiwtx0ab.execute-api.us-west-2.amazonaws.com/default/close/'+sid, obj).then(data => {
        console.log(data);
        this.flags.appSync.data.status = 'closed';
        //this.app.toast('ran close', 'success');
    });
  }


  loadLink() {
    //this.flags.endingSurvey = false;

    var url = document.getElementById("directControlTarget").innerHTML;
    this.flags.appSync.data.data.url = url;
  }


  startSurvey() {
    //this.flags.appSync = null,
    //this.flags.sessionID = null,

    // this.unsubscribe();
    // if(this.room) {
    //   this.stopTwilioConnect();
    // }

    var color = this.flags.editSite.settings.bgColor;
    color = color.replace('#', '');

    var target = 'https://wecare.helloarii.com/assets/api-survey.html?token=' + this.token + '&id=' + this.flags.sessionID + '&image='+this.flags.editSite.settings.surveyImg + '&bgimage=' + this.flags.editSite.settings.bgImage + '&bgcolor='+color;
    this.flags.appSync.data.data.url = target;
    //viewLink(target);
    //this.flags.endingSurvey = true;
  }

  submitSurvey() {
    
    this.flags.endingSurvey = false;
    this.flags.appSync = false;
    this.flags.sessionID = null;
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
        header: 'Are you sure?',
        message: 'You are about to close your support session',
        buttons: [
            {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: (blah) => {
                    console.log('Confirm Cancel: blah');
                }
            }, {
                text: 'End Session',
                handler: () => {
                    //this.remSetting(m, i);
                    this.closeSession();
                    console.log('Confirm Okay');
                }
            }
        ]
    });

    await alert.present();
}
  

  ionViewWillLeave() {
    this.flags.twilioToken = null; ///remove so token checking stops
    if(this.room) {
      this.stopTwilioConnect();
    }
    this.unsubscribe();
  }
  
  ngOnInit() {
  }

}
